import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PersonalDataForm from './components/personalDataForm/PersonalDataForm';
import PasswordForm from './components/passwordForm/PasswordForm';
import AddressView from './components/addressForm/AddressView';
import {
  DATA_ROUTE,
  HOME_ROUTE,
  PASSWORD_ROUTE,
  ADDRESS_ROUTE,
} from '../../../constants/Routes';

const useStyles = makeStyles(() => ({
  container: {
    height: 'auto',
  },
}));

const MyData = ({ ...props }) => {
  const classes = useStyles();
  const { mobile, path } = props;

  return (
    <Box className={classes.container}>
      {(path === DATA_ROUTE || path === HOME_ROUTE) && (
        <PersonalDataForm mobile={mobile} />
      )}
      {path === PASSWORD_ROUTE && <PasswordForm mobile={mobile} />}
      {path === ADDRESS_ROUTE && <AddressView mobile={mobile} />}
    </Box>
  );
};

MyData.propTypes = {
  mobile: PropTypes.bool,
  path: PropTypes.string,
};

export default MyData;
